import { type Avatar } from '@/portal-api.definition';
import { utils } from '@nosinovacao/nosid-mfe-common';
import { type Profile } from 'oidc-client';

export interface ProfileForm {
  type: Profile['Type'];
  name: string;
  hasPin: boolean;
  pin: string | null;
  confirmPin: string | null;
  avatar: Avatar | null;
  ageRating: string | null;
}

export async function profileFormLoaderFn({ location: { hash } }: { location: { hash: string } }) {
  try {
    if (!hash) return null;
    const decodedValue = await utils.decompressFromBase64Url(hash);
    if (!decodedValue) return null;
    const parsed = JSON.parse(decodedValue);
    return {
      ageRating: parsed.ageRating,
      avatar: parsed.avatar,
      name: parsed.name,
      hasPin: !!parsed.hasPin,
      pin: parsed.pin,
      confirmPin: parsed.confirmPin,
    } as Omit<ProfileForm, 'type'>;
  } catch {
    return null;
  }
}
